module.exports = __webpack_public_path__ + "img/icon-contact-service.a8ee0157.png";